module.exports = __webpack_public_path__ + "/bundle/asset/U2_02-2f9b5ec73e2c18c4184a6e69aefefb7f.gif";